import { types, actions } from './requests'
export const DELETETIMECALENDAR_TYPES = {
    ...types('DELETETIMECALENDAR'),
}
export const DELETETIMECALENDAR_ACTIONS = {
    ...actions('DELETETIMECALENDAR'),
}